import React from 'react';
import './CategoryPills.css';

/**
 * Horizontal scrollable pill buttons for category filtering.
 * @param {Array}  categories     - [{ value, label }]
 * @param {string} activeCategory - currently selected value, or "all"
 * @param {function} onChange     - called with the new value string
 * @param {string} allLabel       - label for the "all" pill (default "Todos")
 */
const CategoryPills = ({ categories = [], activeCategory = 'all', onChange, allLabel = 'Todos', className = '' }) => (
  <div className={`cat-pills${className ? ' ' + className : ''}`}>
    <button
      className={`cat-pill${activeCategory === 'all' ? ' active' : ''}`}
      onClick={() => onChange('all')}
    >
      {allLabel}
    </button>
    {categories.map((cat) => (
      <button
        key={cat.value}
        className={`cat-pill${activeCategory === cat.value ? ' active' : ''}`}
        onClick={() => onChange(cat.value)}
      >
        {cat.label}
      </button>
    ))}
  </div>
);

export default CategoryPills;
